// /home/oh33090489/real-estate-app/frontend/src/api/authApi.js

// =========================
// JWT 자동 첨부 fetch 래퍼
// =========================
async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    // 토큰 만료/무효
    localStorage.removeItem("token");
    throw new Error("unauthorized");
  }

  return res;
}

export async function kakaoLogin(accessToken) {
  const res = await fetch("/api/auth/kakao", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      access_token: accessToken,
    }),
  });

  if (!res.ok) {
    throw new Error("kakao login failed");
  }

  const data = await res.json();
  // 🔥 핵심: JWT 저장
  if (data?.token) {
    localStorage.setItem("token", data.token);
  }
  return data;
}

// ===== 이메일 회원가입 / 로그인 =====

export async function sendEmailCode(email) {
  const res = await fetch("/api/auth/email/send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) throw new Error("send email code failed");
  return res.json();
}

// =========================
// 로그인 사용자 정보 조회
// =========================
export async function getMe() {
  const res = await authFetch("/api/auth/me");
  if (!res.ok) throw new Error("get me failed");
  return res.json();
}

export async function verifyEmailCode(email, code) {
  const res = await fetch("/api/auth/email/verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, code }),
  });
  if (!res.ok) throw new Error("verify email code failed");
  return res.json();
}

export async function registerEmail(data) {
  const res = await fetch("/api/auth/register", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("email register failed");
  return res.json();
}

export async function loginEmail(email, password) {
  const res = await fetch("/api/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error("email login failed");
  const data = await res.json();
  // 🔥 핵심: JWT 저장
  if (data?.token) {
    localStorage.setItem("token", data.token);
  }
  return data;
}